/** Joins truthy class names. */
const cx = (...names: Array<string | false | null | undefined>): string =>
  names.filter(Boolean).join(" ");

export default cx;
